import Vue from 'vue'
import CONFIG from './../../config.js'

let actions = {
  getStatement (context, params) {
    context.commit('addLog', { request: 'getPlans' })

    Vue.axios.get(`${CONFIG.getEndpoint('getPlans', 'Mobile')}?operator=Jio&region=Maharashtra`, {
      withCredentials: true,
      xsrfCookieName: 'SSO_TOKEN'
    }).then((response) => {
      // console.log(response)
      context.commit('removeLog', { request: 'getPlans' })
      context.commit('set_statement', response.data.plans)
      context.commit('set_statement_categories', response.data.categories)
    }).catch(() => {
      context.commit('removeLog', { request: 'getPlans' })
    })
  },
  filterStatement (context, params) {
    context.commit('filter_statement', params)
  },
  recentTransactions (context, query) {
    let append = query.append
    context.commit('addLog', { request: 'recentTransactions' })
    return new Promise((resolve, reject) => {
      if (query.append) {
        query = query.params
      }
      Vue.axios.get(CONFIG.getEndpoint('recentTransactions'), {
        params: query,
        withCredentials: true
      }).then((response) => {
        // console.log(response.data.statements);
        context.commit('set_recentTransactions', {
          response: response.data.statements,
          append: append
        })
        context.commit('set_transactionsCount', {
          response: response.data.totalCount
        })
        context.commit('removeLog', { request: 'recentTransactions' })
        resolve()
      }).catch((err) => {
        context.commit('removeLog', { request: 'recentTransactions' })
        reject(err)
      })
    })
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/statement/actions.js